import './contact.css'
import { ReactComponent as Facebook } from '../../icons/facebook.svg';
import { ReactComponent as Instagram } from '../../icons/instagram.svg';
import { ReactComponent as Linkedin } from '../../icons/linkedin.svg';

export default function Contact() {
  return (
    <div className='contact'>
      <div className='contactcntr'>
        <div className='inputfieldcntr'>
          <h1>Contact Me</h1>
        </div>
        <div className='inputfieldcntr'>
          <input type='text' placeholder='Your Name'/>
        </div>
        <div className='inputfieldcntr'>
          <input type='email' placeholder='Your Email'/>
        </div>
        <div className='inputfieldcntr'>
          <input type='tel' placeholder='Your Phone Number'/>
        </div>
        <div className='inputfieldcntr'>
          <textarea rows="4" placeholder='Your Message Here'></textarea>
        </div>
        <div className='inputfieldcntr'>
          <button>Submit</button>
        </div>
        <div className='inputfieldcntr'>
          <div className='socialmediabox'>
            <a href='#abc'><Facebook fill='blue'/></a>
            <a href='#abc'><Instagram fill='purple'/></a>
            <a href='#abc'><Linkedin  fill='#0A66C2'/></a>
          </div>
        </div>
      </div>
    </div>
  )
}
